import { useLanguage } from '../context/LanguageContext';
import { translations as enTranslations } from '../translations/en';
import { translations as arTranslations } from '../translations/ar';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = language === 'ar' ? arTranslations : enTranslations;
  
  return { t, language };
};
